function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "Group 7.11");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created using Figma");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Canvas",
  transform: "translate(17955 -19634)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 7.11"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 6.6"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path0_stroke",
  transform: "matrix(1 -1.44723e-16 -6.58127e-17 1 -17948.7 19634.8)",
  fill: "#FFFFFF"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group 6.8"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path0_stroke",
  transform: "matrix(-1 2.67188e-16 -5.66519e-17 -1 -17948.7 19645.7)",
  fill: "#FFFFFF"
})))));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path0_stroke",
  d: "M 0 5.45936L -0.347204 5.09957L -0.720038 5.45936L -0.347204 5.81915L 0 5.45936ZM 5.31008 -0.359791L -0.347204 5.09957L 0.347204 5.81915L 6.00449 0.359791L 5.31008 -0.359791ZM -0.347204 5.81915L 5.31008 11.2785L 6.00449 10.5589L 0.347204 5.09957L -0.347204 5.81915Z"
}));

var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/Cross.a81945c4.svg";
export { SvgCross as ReactComponent };